import { CONFIG } from '../config';
import { isClientSide } from '../lib/isClientSide';

export const USER_API_URL =
  isClientSide() && window.__FEATURE_FLAGS__?.['user-api-proxy']
    ? `${CONFIG.DISCOVERY_API_URL}/user-api`
    : CONFIG.USER_API_URL;
